// Ready-made profile avatars (clean, minimal, premium-look SVGs in /public/avatars).
// Anyone can pick one - they are free. To add more, drop an SVG into public/avatars
// and add a line here. `url` is what gets saved in the user's `avatar` field.
export const AVATAR_PRESETS = [
  { id: 'nova', label: 'Nova' },
  { id: 'aurora', label: 'Aurora' },
  { id: 'onyx', label: 'Onyx' },
  { id: 'sakura', label: 'Sakura' },
  { id: 'cyber', label: 'Cyber' },
  { id: 'velvet', label: 'Velvet' },
  { id: 'solar', label: 'Solar' },
  { id: 'frost', label: 'Frost' },
  { id: 'ember', label: 'Ember' },
  { id: 'orchid', label: 'Orchid' },
  { id: 'jade', label: 'Jade' },
  { id: 'mono', label: 'Mono' },
  { id: 'midnight', label: 'Midnight' },
  { id: 'coral', label: 'Coral' },
  { id: 'sapphire', label: 'Sapphire' },
  { id: 'royal', label: 'Royal' },
].map((a) => ({ ...a, url: `/avatars/${a.id}.svg` }))

// Stable "random" preset for a seed (used as the default avatar for brand-new accounts).
export function presetForSeed(seed: string): string {
  const h = seed.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0)
  return AVATAR_PRESETS[h % AVATAR_PRESETS.length].url
}
